import regular from '~/static/svg/font-weights/weight-regular.svg';
import semibold from '~/static/svg/font-weights/weight-semibold.svg';
import bold from '~/static/svg/font-weights/weight-bold.svg';
import black from '~/static/svg/font-weights/weight-black.svg';
import {i18n} from '~/i18n';

export const fontWeights = {
  normal: {icon: regular, label: i18n('font-weight.regular'), value: 'normal'},
  semibold: {icon: semibold, label: i18n('font-weight.semibold'), value: 500},
  bold: {icon: bold, label: i18n('font-weight.bold'), value: 'bold'},
  black: {icon: black, label: i18n('font-weight.black'), value: 900},
};

export const getBoldKey = value => value === true ? 'bold' : value || 'normal';
export const getBoldStyle = value => (fontWeights[getBoldKey(value)] || fontWeights['normal']).value;